<template>
     <div class="container-fluid">
         <b-row >
            <b-col lg="12" >
               <card class=" card-block card-stretch card-height blog">
                  <template v-slot:headerTitle>
                        <h4 class="card-title">Basic Pricing Box</h4>
                  </template>
                  <template v-slot:body>
                     <ul class="row align-items-center list-inline p-0 mb-0">
                        <li class="col-lg-3 col-md-6 col-sm-12">
                           <div class="p-3 border text-center rounded"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder ">$26<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-md-0">
                           <div class="p-3 border text-center rounded"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder">$99<small class="font-size-14">/ Month</small></h2>
                              <ul class="list-unstyled mb-0 ">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-lg-0">
                           <div class="p-3 border text-center rounded"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder ">$39<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-lg-0">
                           <div class="p-3 border text-center rounded"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder ">$25<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                     </ul>
                  </template>
               </card>
            </b-col>
            <b-col lg="12" >
               <card class=" card-block card-stretch card-height blog">
                  <template v-slot:headerTitle>
                        <h4 class="card-title">Radious Pricing Box</h4>
                  </template>
                  <template v-slot:body>
                     <ul class="row align-items-center list-inline p-0 mb-0">
                        <li class="col-lg-3 col-md-6 col-sm-12">
                           <div class="p-3 border text-center pricing-radius-box"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder ">$26<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-md-0">
                           <div class="p-3 border text-center pricing-radius-box"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder">$99<small class="font-size-14">/ Month</small></h2>
                              <ul class="list-unstyled mb-0 ">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-lg-0">
                           <div class="p-3 border text-center pricing-radius-box"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder ">$39<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-lg-0">
                           <div class="p-3 border text-center pricing-radius-box"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder">$25<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                     </ul>
                  </template>
               </card>
            </b-col>
            <b-col lg="12" >
               <card class=" card-block card-stretch card-height blog">
                   <template v-slot:headerTitle>
                        <h4 class="card-title">Normal Pricing Box</h4>
                   </template>
                  <template v-slot:body>
                     <ul class="row align-items-center list-inline p-0 mb-0">
                        <li class="col-lg-3 col-md-6 col-sm-12">
                           <div class="p-3 border text-center"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder ">$26<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-md-0">
                           <div class="p-3 border text-center"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder">$99<small class="font-size-14">/ Month</small></h2>
                              <ul class="list-unstyled mb-0 ">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-lg-0">
                           <div class="p-3 border text-center"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder ">$39<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-lg-0">
                           <div class="p-3 border text-center"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder ">$25<small class="font-size-14 text-muted">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn btn-primary mt-5">Start Starter</a>
                           </div>
                        </li>
                     </ul>
                  </template>
               </card>
            </b-col>
            <b-col lg="12" >
               <card class=" card-block card-stretch card-height blog">
                   <template v-slot:headerTitle>
                        <h4 class="card-title">Color Pricing Box</h4>
                      </template>
                  <template v-slot:body>
                     <ul class="row align-items-center list-inline p-0 mb-0">
                        <li class="col-lg-3 col-md-6 col-sm-12">
                           <div class="p-3 border text-center bg-primary text-white pricing-radius-box"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder text-white">$26<small class="font-size-14">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn bg-white mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-md-0">
                           <div class="p-3 border text-center bg-warning text-white pricing-radius-box"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder text-white">$99<small class="font-size-14">/ Month</small></h2>
                              <ul class="list-unstyled mb-0 ">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn bg-white mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-lg-0">
                           <div class="p-3 border text-center bg-success text-white pricing-radius-box"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder text-white">$39<small class="font-size-14">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn bg-white mt-5">Start Starter</a>
                           </div>
                        </li>
                        <li class="col-lg-3 col-md-6 col-sm-12 mt-3 mt-lg-0">
                           <div class="p-3 border text-center bg-danger text-white pricing-radius-box"> <span class="font-size-16 text-uppercase">Basic</span>
                              <h2 class="mb-4 display-3 font-weight-bolder text-white">$25<small class="font-size-14">/ Month</small></h2>
                              <ul class="list-unstyled mb-0">
                                 <li>Lorem ipsum dolor sit amet</li>
                                 <li>Consectetur adipiscing elit</li>
                                 <li>Integer molestie at massa</li>
                                 <li>Facilisis in pretium nisl aliquet</li>
                                 <li>Nulla volutpat aliquam velit</li>
                              </ul> <a href="#" class="btn bg-white mt-5">Start Starter</a>
                           </div>
                        </li>
                     </ul>
                   </template>
               </card>
            </b-col>
         </b-row>
      </div>
</template>
<script>
export default {
    name:'Pricing2'
}
</script>